export default __webpack_public_path__ + "static/media/Animations_Cog2.973b6b8e.svg";